import cn from '../StockImportsTab/StockImportsTab.module.scss'

export const requiredLabel = (text: string) => (
  <span>
    {text}
    <span className={cn.requiredMark}>*</span>
  </span>
)
